module.exports = __webpack_public_path__ + "static/media/product_cheese.fd346366.png";